import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { LoginDIRFormSchema, LoginDIRMutation } from './LoginDIRForm.types';
import { getLoginDIRForm } from './LoginDIRForm.schema';
import { useMutation, useQueryClient } from 'react-query';
import { loginDIRFormData } from './LoginDIRForm.data';
import Form from '../../../../commons/Form/Form';
import { LOGIN_DIR_QUERY_KEY, loginDIRQuery } from './LoginDIRForm.query';
import { setProfile } from '../../../../../store/authentication/authenticationActions/authenticationActions';
import { UserRoles } from '../../../../../types/models/user/user.types';
import { api } from '../../../../../utils/api/api';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';

export default () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [, setCookie] = useCookies(['token']);

  const formProps = useForm<LoginDIRFormSchema>({
    resolver: yupResolver(getLoginDIRForm),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const { handleSubmit } = formProps;

  const { mutate } = useMutation<Awaited<ReturnType<LoginDIRMutation>>, Error, LoginDIRFormSchema>(
    (data) => loginDIRQuery(data),
    {
      mutationKey: LOGIN_DIR_QUERY_KEY,
      onMutate: () => queryClient.cancelMutations(),
      onSuccess: ({ user, accessToken }) => {
        setProfile({ ...user, role: UserRoles.DirecteurCommercial })(dispatch);
        api.setHeader('authorization', `Bearer ${accessToken}`);
        setCookie('token', accessToken, {
          expires: moment().add(60, 'minutes').toDate(),
          path: '/',
        });
        navigate('/dashboard');
      },
      onError: (error) => alert(error.message),
    }
  );

  const onSubmit = handleSubmit((data) => mutate(data));

  return (
    <>
      <Form<LoginDIRFormSchema>
        data={loginDIRFormData}
        style={{
          width: 400,
          alignSelf: 'center',
        }}
        {...{ formProps, onSubmit }}
        // afterInputsElement={<Link to='/password/forgot/DIR'>
        //   <span className='form__after-inputs-link text-primary'>Mot de passe oublié ?</span>
        // </Link>}
      />
    </>
  );
};
